export default __webpack_public_path__ + "static/media/startprotection.7593ceb0.jpg";